import React from 'react'
import {
  ApplicationFulfillment,
  AttachmentWithAccessibility,
} from 'types/common'
import { Attachments } from 'components/scouts/profile-detail/attachments'
import {
  ProfileDetailCoverLetterBox,
  ProfileDetailCoverLetterSectionTitle,
  ProfileDetailSection,
  ProfileDetailSectionTitle,
} from 'components/scouts/profile-detail/styles'
import { PositionApplicationFulfillmentCondition } from 'components/scouts/profile/common/application-fulfillment-condition'
import { LineLimitedText } from 'components/scouts/profile-detail/desc-more-view'
import { Column } from 'components/common/layout'
import {
  UserBaseInfo,
  UserBaseInfoProps,
} from 'components/scouts/profile/common/user-base-info'
import { hasFitApplicationFulfillment } from 'utils/validations'

export const ApplicationInfoWithoutProfile: React.FC<{
  user: UserBaseInfoProps
  application: {
    files: AttachmentWithAccessibility[]
    links: AttachmentWithAccessibility[]
    joinReason: string
    fitReason: string
    fulfillments: ApplicationFulfillment
  }
  showEmptyContent?: boolean
}> = ({ user, application, showEmptyContent }) => {
  const { files, links, joinReason, fitReason, fulfillments } = application
  return (
    <Column style={{ gap: 40 }}>
      <UserBaseInfo data={user} />
      {fulfillments &&
        (hasFitApplicationFulfillment(fulfillments) || showEmptyContent) && (
          <PositionApplicationFulfillmentCondition
            userName={user.name}
            fulfillments={fulfillments}
          />
        )}
      {(joinReason || fitReason || showEmptyContent) && (
        <ProfileDetailCoverLetterBox>
          {(joinReason || showEmptyContent) && (
            <Column style={{ gap: 4 }}>
              <ProfileDetailCoverLetterSectionTitle>
                합류하고 싶은 이유
              </ProfileDetailCoverLetterSectionTitle>
              <LineLimitedText text={joinReason} lineClamp={2} />
            </Column>
          )}
          {(fitReason || showEmptyContent) && (
            <Column style={{ gap: 4 }}>
              <ProfileDetailCoverLetterSectionTitle>
                적합하다 생각하는 이유
              </ProfileDetailCoverLetterSectionTitle>
              <LineLimitedText text={fitReason} lineClamp={2} />
            </Column>
          )}
        </ProfileDetailCoverLetterBox>
      )}
      <ProfileDetailSection>
        <ProfileDetailSectionTitle>첨부 자료</ProfileDetailSectionTitle>
        <Attachments files={files} links={links} />
      </ProfileDetailSection>
    </Column>
  )
}
